<portal-card
  [collapsed]="collapsed"
  [ngClass]="{ 'g-cursor-pointer': disabled === false, 'g-cursor-default': disabled === true }"
  [state]="state"
  bodyClasses="g-no-transitions"
  type="bg"
>
  <span header>
    @if (stateIcon !== undefined) {
      <i
        class="me-2"
        [ngClass]="stateIcon"
        [portalTippy]="stateTooltip | translate"
        [tippyDisabled]="stateTooltip === undefined"
      ></i>
    }

    <!-- header content -->
    <ng-container [ngTemplateOutlet]="headerTemplate" [ngTemplateOutletContext]="context"></ng-container>
  </span>

  <span actions>
    @if (bodyTemplate !== undefined) {
      <portal-icon-button
        (onClick)="toggleCollapse($event)"
        iconClass="{{ collapsed ? 'far fa-angle-down' : 'far fa-angle-left' }}"
      ></portal-icon-button>
    }
  </span>

  <ng-container inbetween>
    <ng-container
      *ngTemplateOutlet="errorTemplate || defaultError; context: { error: bulkActionEntry.failure }"
    ></ng-container>

    <ng-template #defaultError>
      @if (bulkActionEntry.failure != null) {
        <portal-error-alert [error]="$any(bulkActionEntry.failure).error || $any(bulkActionEntry.failure)">
          {{ bulkActionEntry.failure }}
        </portal-error-alert>
      }
    </ng-template>
  </ng-container>

  <ng-container [ngTemplateOutlet]="bodyTemplate" [ngTemplateOutletContext]="context"></ng-container>
</portal-card>
